module.exports = __webpack_public_path__ + "img/founders-four.0642a952.png";